import React from 'react';
import { styled } from '@mui/material/styles';
import { Paper, Button, Typography, Link } from '@mui/material';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import { useNavigate } from 'react-router-dom';

const PREFIX = 'ParentOrganizationHeader';

const classes = {
  container: `${PREFIX}-container`,
  previous: `${PREFIX}-previous`,
  title: `${PREFIX}-title`,
};

const StyledBox = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
  },

  [`& .${classes.previous}`]: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },

  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    fontSize: 30,
    fontWeight: 700,
  },
}));

interface ParentOrganizationHeaderProps {
  name: string;
}

export default function ClientHeader({ name }: ParentOrganizationHeaderProps) {
  const t = useCommonTranslation();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <StyledBox elevation={0} className={classes.container}>
      <Link
        color="primary"
        className={classes.previous}
        href="#"
        onClick={goBack}
        underline="hover">
        <ArrowBackIos />
        {t('common.back')}
      </Link>
      <Typography className={classes.title}>{name}</Typography>
      <div></div>
    </StyledBox>
  );
}
